import { Unlocked as Unlocked_phosphor } from './Unlocked.phosphor';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    default:
      return Unlocked_phosphor;
  }
};

export const Unlocked = IconRenderer();
